const DEV = process.env.NODE_ENV === 'development'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  init() {
    function isTouchDevice() {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      )
    }

    jQuery(document).ready(function ($) {
      //Animazione diagramma
      const diagram = $('#diagramBlock')
      const blocks = $('.diagram_block')
      const arrows = $('.arrow_desktop')

      if (
        diagram.length &&
        blocks.length &&
        arrows.length &&
        !isTouchDevice()
      ) {
        gsap.set(blocks, { opacity: 0 })
        arrows.each(function () {
          const isVertical = $(this).hasClass('arrow_desktop_vertical')
          gsap.set(this, {
            opacity: 0,
            [isVertical ? 'height' : 'width']: 10,
          })
        })

        const mainTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: diagram,
            start: 'top 80%',
          },
        })

        // Sequenza precisa
        const sequence = [
          { type: 'block', index: 0 },
          { type: 'arrow', index: 0 },
          { type: 'block', index: 1 },
          { type: 'arrow', index: 1 },
          { type: 'block', index: 2 },
          { type: 'arrow', index: 2 },
          { type: 'block', index: 3 },
          { type: 'arrow', index: 3 },
          { type: 'block', index: 4 },
          { type: 'arrow', index: 5 }, // freccia 5 prima di blocco 5
          { type: 'block', index: 5 },
          { type: 'curve', id: '#arrowCL', prop: 'height' },
          { type: 'curve', id: '#arrowCT', prop: 'width' },
          { type: 'curve', id: '#arrowCR', prop: 'height' },
          { type: 'arrow', index: 4 }, // freccia 4 DOPO curve
          { type: 'block', index: 6 },
          { type: 'arrow', index: 6 },
          { type: 'block', index: 7 },
        ]

        let delay = 0

        sequence.forEach((item, i) => {
          if (item.type === 'block') {
            mainTimeline.to(
              blocks.eq(item.index),
              { opacity: 1, duration: 0.3 },
              `+=${delay}`
            )
            delay = 0.1
          } else if (item.type === 'arrow') {
            mainTimeline.to(
              arrows.eq(item.index),
              { opacity: 1, duration: 0.05 },
              `+=${delay}`
            )
            mainTimeline.to(
              arrows.eq(item.index),
              {
                width: function (i, target) {
                  return $(target).hasClass('arrow_desktop_vertical')
                    ? $(target).width()
                    : '100%'
                },
                height: function (i, target) {
                  return $(target).hasClass('arrow_desktop_vertical')
                    ? '100%'
                    : $(target).height()
                },
                duration: 0.1,
              },
              '>'
            )
            delay = 0.1
          } else if (item.type === 'curve') {
            mainTimeline.to(
              item.id,
              { [item.prop]: 0, duration: 0.1 }
              //`+=${delay}`
            )
            delay = 0.1
          }
        })
      }
    })

    //TIMER CONCLAVE

    let dayShort = document.getElementById('day_short').textContent
    let hourShort = document.getElementById('hour_short').textContent
    let minShort = document.getElementById('min_short').textContent
    let secShort = document.getElementById('sec_short').textContent

    const timerElement = document.getElementById('currentConclave'),
      shorterBlock = document.getElementById('shorterBlock'),
      shorterElement = document.getElementById('shorterConclave'),
      longerBlock = document.getElementById('longerBlock'),
      longerElement = document.getElementById('longerConclave'),
      shorterElementName = document.getElementById('shorterConclaveName'),
      longerElementName = document.getElementById('longerConclaveName'),
      timerStart = document.getElementById('timerStart'),
      timerEnded = document.getElementById('timerEnded'),
      startDate = new Date(timerStart.value),
      endDate = new Date(timerEnded.value)
    let conclaveDurations = []
    function loadConclavesFromCSV() {
      if (!timerCsvUrl) {
        console.error('⚠️ Errore: csvUrl è indefinito o vuoto.')
        return
      }

      fetch(timerCsvUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Errore nel fetch: ${response.status} ${response.statusText}`
            )
          }
          return response.text()
        })
        .then((text) => {
          const lines = text.trim().split('\n')

          if (lines.length <= 1) {
            throw new Error('CSV vuoto o senza dati utili.')
          }

          const dataLines = lines.slice(1)

          conclaveDurations = dataLines.map((line) => {
            const cols = line.split(',')

            const name = cols[1].trim()
            const startStr = convertToISO(cols[3].trim(), cols[5].trim())
            const endStr = convertToISO(cols[4].trim(), cols[6].trim())

            const start = new Date(startStr)
            const end = new Date(endStr)
            const duration = (end - start) / 1000

            return { name, start, end, duration }
          })

          updateTimer()
          setInterval(updateTimer, 1000)
        })
        .catch((err) => {
          console.error(
            '❌ Errore durante il caricamento del CSV:',
            err.message
          )
        })
    }

    function updateTimer() {
      const now = new Date()
      let diffInSeconds = 0
      if (endDate instanceof Date && !isNaN(endDate)) {
        diffInSeconds = Math.floor((endDate - startDate) / 1000)
      } else {
        diffInSeconds = Math.floor((now - startDate) / 1000)
      }

      if (diffInSeconds < 0) diffInSeconds = 0

      timerElement.innerHTML = formatDuration(diffInSeconds)

      if (conclaveDurations.length > 0) {
        let shorter = null,
          longer = null

        for (const conclave of conclaveDurations) {
          if (
            conclave.duration <= diffInSeconds &&
            (!shorter || conclave.duration > shorter.duration)
          ) {
            shorter = conclave
          }
          if (
            conclave.duration >= diffInSeconds &&
            (!longer || conclave.duration < longer.duration)
          ) {
            longer = conclave
          }
        }

        if (shorter) {
          shorterElement.innerHTML = formatDuration(shorter.duration, false)
          shorterElementName.innerHTML = shorter.name
          shorterBlock.style.display = 'flex'
        } else {
          shorterBlock.style.display = 'none'
        }
        if (longer) {
          longerElement.innerHTML = formatDuration(longer.duration, false)
          longerElementName.innerHTML = longer.name
          longerBlock.style.display = 'flex'
        } else {
          longerBlock.style.display = 'none'
        }
      }
    }

    function pad(n) {
      return n.toString().padStart(2, '0')
    }

    function convertToISO(dateStr, timeStr) {
      const [day, month, year] = dateStr.split('/')
      return `${year}-${month}-${day}T${timeStr}`
    }

    function formatDuration(seconds, showSeconds = true) {
      const days = Math.floor(seconds / (3600 * 24))
      const hours = Math.floor((seconds % (3600 * 24)) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = Math.floor(seconds % 60)

      if (days > 0) {
        return `<span>${pad(days)}</span>${dayShort}
						<span>${pad(hours)}</span>${hourShort}
						<span>${pad(minutes)}</span>${minShort}`
      } else {
        return `<span>${pad(hours)}</span>${hourShort}
						<span>${pad(minutes)}</span>${minShort}
						${showSeconds ? `<span>${pad(secs)}</span>${secShort}` : ''}`
      }
    }

    loadConclavesFromCSV()
  },
  finalize() {
    // JavaScript da eseguire su tutte le pagine dopo lo specifico
  },
}
